import { useLocation, useNavigate } from 'react-router-dom';
import Form, { FormProps } from '..';
import useStore from '../../Hooks/useStore';
import FormRecoverPasswordRequest from './RecoverPasswordRequest';
import './Recover.css';
import { useSnackbar } from 'notistack';
import SVG from '../../SVG';
import { useEffect, useState } from 'react';

interface FormRecoverPasswordProps extends FormProps {}

function FormRecoverPassword({
  children,
  className = '',
  ...rest
}: FormRecoverPasswordProps) {
  const [getters, setters] = useStore();
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();

  const searchParams = new URLSearchParams(location.search);
  const code = searchParams.get('code');
  const {
    form: { getForm, getRecoverFormMessage },
  } = getters;

  const {
    form: {
      setForm,
      blurRecoverForm,
      getRecoverFormValidation,
      resetRecoverForm,
    },
    user: { updateUserPassword },
  } = setters;

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    resetRecoverForm();
  }, []);

  useEffect(() => {
    if (code) setForm('recoverPassword.code', code);
  }, [code]);

  const Check = ({ checked = false }: any) => {
    return (
      <label
        style={{
          marginRight: '0.5rem',
        }}
      >
        {checked ? <SVG.Icon.Check /> : <SVG.Icon.Uncheck />}
      </label>
    );
  };
  const messages = getRecoverFormMessage();
  const blur = () => {
    blurRecoverForm('password');
    blurRecoverForm('passwordConfirmation');
  };

  const onSubmit = (e: any) => {
    e.preventDefault();
    const result = getRecoverFormValidation([
      'password',
      'passwordConfirmation',
    ]);
    if (result) {
      setLoading(true);
      updateUserPassword()
        .then(() => {
          setLoading(false);
          resetRecoverForm();
          enqueueSnackbar('Senha atualizada com sucesso', {
            variant: 'success',
          });
          navigate('/');
        })
        .catch((error) => {
          setLoading(false);
          enqueueSnackbar(error.message, {
            variant: 'error',
          });
        });
    }
  };
  return (
    <Form
      className="form-recover"
      style={{
        display: 'grid',
      }}
      onSubmit={onSubmit}
    >
      <Form.Input.Password
        label="Senha"
        value={getForm('recoverPassword.password')}
        onBlur={blur}
        onChange={(e) => {
          setForm('recoverPassword.password', e.target.value);
          blur();
        }}
      />
      <Form.Input.Password
        label="Confirmar senha"
        errorMessage={false}
        value={getForm('recoverPassword.passwordConfirmation')}
        onBlur={blur}
        onChange={(e) => {
          setForm('recoverPassword.passwordConfirmation', e.target.value);
          blur();
        }}
      />

      <div>
        <ul className="recover-validation-list">
          <li>
            <label>
              <Check
                checked={
                  !messages.password['atLeast'] ||
                  !messages.passwordConfirmation['atLeast']
                }
              />
            </label>
            <label>Ao menos seis caracteres</label>
          </li>
          <li>
            <label>
              <Check
                checked={
                  !messages.password['oneLetter'] ||
                  !messages.passwordConfirmation['oneLetter']
                }
              />
            </label>
            <label>Contém no mínimo uma letra</label>
          </li>
          <li>
            <label>
              <Check
                checked={
                  !messages.password['oneNumber'] ||
                  !messages.passwordConfirmation['oneNumber']
                }
              />
            </label>
            <label>Contém no mínimo um número</label>
          </li>
          <li>
            <label>
              <Check
                checked={
                  !messages.password['oneSpecialCharacter'] ||
                  !messages.passwordConfirmation['oneSpecialCharacter']
                }
              />
            </label>
            <label>Contém no mínimo um caractere especial</label>
          </li>
          <li>
            <label>
              <Check
                checked={
                  !messages.password['samePassword'] ||
                  !messages.passwordConfirmation['samePassword']
                }
              />
            </label>
            <label>Senhas coincidentes</label>
          </li>
        </ul>
      </div>

      <Form.Button
        type="submit"
        style={{
          padding: '0',
          height: '55px',
          width: '200px',
          fontSize: '32px',
          margin: 'auto',
        }}
        loading={loading}
        disabled={loading}
      >
        Enviar
      </Form.Button>
    </Form>
  );
}
export default Object.assign(FormRecoverPassword, {
  Request: FormRecoverPasswordRequest,
});
